exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ch2-additional-options textarea.special-wish[data-v-74ec2ec5]{height:42px;width:100%;margin-top:8px;min-height:0}.ch2-additional-options textarea.special-wish.opened[data-v-74ec2ec5]{min-height:150px;height:auto}.ch2-additional-options textarea.special-wish[data-v-74ec2ec5]:not(.opened){padding:9px}@media(max-width:480px){.ch2-additional-options textarea.special-wish[data-v-74ec2ec5]{height:62px}}", ""]);

// exports
